import { render, staticRenderFns } from "./BtnDownload.vue?vue&type=template&id=16305b0e"
import script from "./BtnDownload.vue?vue&type=script&lang=js"
export * from "./BtnDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports